<template>
  <div class="market-list-wrap">
    <div class="market-wrap">
      <div class="market-title">{{ $t('landing.market.title') }}</div>
      <div class="market-view-all">
        <span @click="$router.push({ name: 'markets' })">{{ $t('landing.market.viewMore') }}</span>
      </div>
      <AllMarketTable :record-to-show="recordToShow"></AllMarketTable>
    </div>
  </div>
</template>
<script>
import AllMarketTable from './AllMarketTable';

export default {
  components: {
    AllMarketTable
  },
  data() {
    return {
      recordToShow: -1
    };
  }
};
</script>

<style lang="stylus" scoped>
.market-list-wrap {
  margin: 0 auto;
  max-width: 1240px;
  padding-bottom: 100px;

  .market-wrap {
    margin: 0 20px;

    .market-title {
      font-size: 30px;
      line-height: 40px;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      padding-top: 30px;
      padding-bottom: 5px;
    }

    .market-view-all {
      font-size: 14px;
      font-weight: bold;
      line-height: 20px;
      color: rgba(43, 110, 216, 1);
      text-align: center;
      padding-bottom: 35px;
      user-select: none;

      span{
        cursor: pointer;
      }
    }
  }
}
</style>
